<template>
  <div class="box mt-0 px-0">
    <v-layout
      class="wrapper text-xs-center"
      :style="{ 'min-height': `${minHeight}px` }"
      fill-height
      align-center
      justify-center
      row
    >
      <v-progress-circular indeterminate color="accent" />
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    minHeight: {
      type: Number,
      default: 422
    }
  }
}
</script>
